/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { Injectable } from '@angular/core';
import { HealthService } from './health.service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from './environment.service';
import { Configuration } from 'CalltakingCoreApi';
import { ServiceConfiguration, ServiceName } from '../../../assets/config/environment';
import { ClusterUrlProviderService } from './cluster-url-provider.service';

@Injectable({ providedIn: 'root' })
export class CtcService extends HealthService {
    private readonly CTC_CONFIG_URL = '/api/config/v1/load';

    constructor(
        protected http: HttpClient,
        protected env: EnvironmentService,
        protected clusterUrlProviderService: ClusterUrlProviderService
    ) {
        super(http, ServiceName.CTC, env.environment.SERVICES[ServiceName.CTC] ? env.environment.SERVICES[ServiceName.CTC] :
                ([{rackId: 'none', url: clusterUrlProviderService.getCtcUrl()} as ServiceConfiguration]),
            '/api/actuator/health/liveness', Boolean(env.environment.SERVICES[ServiceName.CTC]));
    }

    public requestCtcConfiguration() {
        return this.http.get<Configuration>(`${this.activeUrl$.value}${this.CTC_CONFIG_URL}`, {
            observe: 'body',
            responseType: 'json'
        });
    }
}
